var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-336.853 -343.894)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.037,350.773a2.064,2.064,0,1,0-2.064-2.063A2.065,2.065,0,0,0,354.037,350.773Zm0-3.1a1.031,1.031,0,1,1-1.032,1.031A1.031,1.031,0,0,1,354.037,347.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.165,343.894h-7.54a.689.689,0,0,0-.487.2L337.054,357.18a.688.688,0,0,0,0,.972l7.54,7.541a.689.689,0,0,0,.973,0l13.084-13.085a.688.688,0,0,0,.2-.486v-7.54A.688.688,0,0,0,358.165,343.894Zm-.688,7.943-12.4,12.4-6.568-6.567,12.4-12.4h6.567Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/prices.ceed0be893dad551ec7c9cc4521b1fca.svg";
export { ForwardRef as ReactComponent };